import { enabledCardsService } from '@afterpaytouch/portal-api/consumer/enabledCards'

export const { useGetEnabledCardsQuery } = enabledCardsService
